// Chat Management Actions
export const CHAT_ACTION_STARTS = 'CHAT_ACTION_STARTS';
export const CHAT_ACTION_ERRORS = 'CHAT_ACTION_ERRORS';

// Get all chats
export const GET_ALL_CHATS = 'GET_ALL_CHATS';
export const GET_CHAT_BY_ID = 'GET_CHAT_BY_ID';
export const GET_USER_CHATS = 'GET_USER_CHATS';

// Create, Update, Delete chats
export const CREATE_CHAT = 'CREATE_CHAT';
export const UPDATE_CHAT = 'UPDATE_CHAT';
export const DELETE_CHAT = 'DELETE_CHAT';

// Action creators
export const chatActionStarts = () => ({
  type: CHAT_ACTION_STARTS,
});

export const chatActionErrors = (error: string) => ({
  type: CHAT_ACTION_ERRORS,
  payload: error,
});

export const getAllChatsAction = (chats: any[]) => ({
  type: GET_ALL_CHATS,
  payload: chats,
});

export const getChatByIdAction = (chat: any) => ({
  type: GET_CHAT_BY_ID,
  payload: chat,
});

export const getUserChatsAction = (chats: any[]) => ({
  type: GET_USER_CHATS,
  payload: chats,
});

export const createChatAction = (chat: any) => ({
  type: CREATE_CHAT,
  payload: chat,
});

export const updateChatAction = (chat: any) => ({
  type: UPDATE_CHAT,
  payload: chat,
});

export const deleteChatAction = (chatId: string) => ({
  type: DELETE_CHAT,
  payload: chatId,
});
